'use strict';
const nearestInset = function (node, relatedNode, inset) {
		if (node.left + node.width < relatedNode.left) {
			return node.left + node.width - inset;
		}
		return node.left + inset;
	},
	calcDx = function (node, relatedNode) {
		const relatedNodeRight = (relatedNode.left + relatedNode.width),
			halfWidth = node.width / 2,
			nodeMidX = node.left + halfWidth,
			relatedNodeMidX = relatedNode.left + (relatedNode.width / 2);
		if (relatedNode.left > node.left + node.width) {
			return relatedNode.left - nodeMidX;
		} else if (relatedNodeRight < node.left) {
			return relatedNodeRight - nodeMidX;
		} else {
			return relatedNodeMidX - nodeMidX;
		}
	},
	nodeCenterPoint = require('./node-center-point');
module.exports = {
	'center': function (node) {
		return Math.round(node.left + node.width * 0.5);
	},
	'center-outset': (node, relatedNode, horizontalInset, connectorTheme) => {
		const relatedNodeCenter = nodeCenterPoint(relatedNode),
			arrowSize = connectorTheme.line.arrowExtension.length + connectorTheme.line.width,
			nodeCenter = nodeCenterPoint(node),
			gapBetweenCenters = Math.abs(relatedNodeCenter.x - nodeCenter.x),
			gapBetweenEdges = gapBetweenCenters - ((relatedNode.width + node.width) / 2),
			margin = gapBetweenEdges < (2 * arrowSize) ? 3 : arrowSize,
			halfWidth = (node.width / 2) + margin,
			halfHeight = (node.height / 2) + margin,
			v = {dy: relatedNodeCenter.y - nodeCenter.y, dx: relatedNodeCenter.x - nodeCenter.x},
			dx1 = v.dy ? Math.abs(v.dx * halfHeight / v.dy) : halfWidth,
			dx = Math.min(dx1, halfWidth) * Math.sign(v.dx);
		return nodeCenter.x + dx;
	},
	'center-separated-inset': (node, relatedNode, horizontalInset) => {
		const topEdgeOfRelatedNode = relatedNode.top,
			topEdgeOfCurrentNode = node.top,
			dx = calcDx(node, relatedNode),
			bottomEdgeOfCurrentNode = node.top + node.height,
			bottomEdgeOfRelatedNode = relatedNode.top + relatedNode.height,
			dy1 = Math.abs(topEdgeOfRelatedNode - bottomEdgeOfCurrentNode),
			dy2 = Math.abs(bottomEdgeOfRelatedNode - topEdgeOfCurrentNode),
			dyMin = Math.min(dy1, dy2),
			halfWidth = node.width / 2,
			pxPerSlot = 20,
			availableSpace = halfWidth - horizontalInset,
			numberOfSlots = 1 + Math.floor(availableSpace / pxPerSlot),
			minYOffsetExpected = 25,
			dy = Math.max(dyMin - minYOffsetExpected, 0),
			dySlotSpacingRatio = 50,
			offsetIncr = Math.min(Math.ceil(dy / dySlotSpacingRatio), numberOfSlots),
			offsetXFromEdge = Math.min(offsetIncr * pxPerSlot, availableSpace),
			offSetFromCenter = availableSpace - offsetXFromEdge,
			offsetX = Math.sign(dx) * offSetFromCenter;
		return Math.round(node.left + halfWidth + offsetX);

	},
	'center-separated': function (node, relatedNode, horizontalInset) {
		const insetY = node.height * 0.2,
			insetX = horizontalInset || 10,
			halfWidth = node.width / 2,
			dy = relatedNode.top - node.top + node.height - insetY,
			dx = calcDx(node, relatedNode),
			requestedOffset = (dx / Math.abs(dy)) * insetY,
			cappedOffset = Math.max(requestedOffset, (halfWidth * -1) + insetX),
			offsetX = Math.min(cappedOffset, halfWidth - insetX);
		return Math.round(node.left + (node.width * 0.5) + offsetX);
	},
	'nearest': function (node, relatedNode) {
		return nearestInset(node, relatedNode, 0);
	},
	'nearest-outset': function (node, relatedNode, horizontalInset, connectorTheme) {
		const arrowSize = connectorTheme.line.arrowExtension.length + connectorTheme.line.width;
		return nearestInset(node, relatedNode, -1 * arrowSize);
	},
	'nearest-inset': nearestInset,
	'left-outset': function (node, relatedNode, horizontalInset, connectorTheme) {
		const arrowSize = connectorTheme.line.arrowExtension.length + connectorTheme.line.width;
		return node.left - arrowSize;
	},
	'left': function(node) {
		return node.left;
	},
	'left-inset': function (node, relatedNode, horizontalInset) {
		return node.left + horizontalInset;
	},
	'right': function(node) {
		return node.left + node.width;
	},
	'right-inset': function (node, relatedNode, horizontalInset) {
		return node.left + node.width - horizontalInset;
	}

};
